/**
 * MRP Overview (/mrp) — output page.
 *
 * Renders stats cards + latest-run alerts + quick links to the other
 * five MRP pages. The shared MRPDashboard component reads `view` to
 * short-circuit the Tabs block and hide the top TabsList.
 */
import MRPDashboard from '@/pages/MRPDashboard';

export default function MRPOverview() {
  return <MRPDashboard view="overview" />;
}
